// extracted by mini-css-extract-plugin
export var layoutContainer = "_4w-0";
export var layoutContainerNoRounding = "_4w-6";
export var layoutContainerOpen = "_4w-5";
export var layoutContainerResizing = "_4w-1";
export var mainContent = "_4w-2";
export var resizeDivider = "_4w-3";
export var slidePanel = "_4w-4";